export default __webpack_public_path__ + "static/media/twitter.a51902a3.svg";